import * as turf from '@turf/turf';

export const firePerimeterLabel = (coords, anchorPos) => {
  const triangles = turf.tesselate(coords);
  let centers = [],
      tArea = 0,
      tLargest,
      anchorPositions = ['center'];
  if(anchorPos){
    anchorPositions.unshift(anchorPos);
  }
  triangles.features.forEach(t => {
    centers.push(turf.centerOfMass(t))
    if(turf.area(t) > tArea){
      tArea = turf.area(t);
      tLargest = t;
    }
  });
  let center = turf.centerOfMass(tLargest);
  window.fireMap.addLayer({
    'id': 'perimeter-label',
    'type': 'symbol',
    'source': {
      "type": "geojson",
      "data": center
    },
    "layout": {
      'text-field': `${coords.properties.name} fire perimeter`,
      'text-variable-anchor': anchorPositions,
      'text-font': ['Overpass Mono SemiBold'],
      'text-size': 14,
      'text-padding': {
        base: 15,
        stops: [[1, 10], [8, 25]],
      },
      'text-allow-overlap': true,
      'text-optional': false
    },
    'paint': {
      'text-color': '#FF7F00',
      'text-opacity': 1,
      'text-halo-color': '#fff',
      'text-halo-width': 3
    }
  }, 'fire-points');

}
